<script lang="ts">
  import { xhr, toast } from "$app/utils"
  import ResponseBox from "./ResponseBox.svelte"

  // let props = $props()
  let { alignment_test }: { alignment_test: AlignmentTestType } = $props()
  let responses = () => {
    alignment_test.alignment_test_responses.filter(
      (r) => r.test_type == "post" && r.completed_at?.length > 0
    )
  }

  //let q1_response = responses

  let post_alignment_scores = {}

  if (alignment_test.post_alignment_scores) {
    post_alignment_scores[1] = alignment_test.post_alignment_scores["1"]
    post_alignment_scores[2] = alignment_test.post_alignment_scores["2"]
    post_alignment_scores[3] = alignment_test.post_alignment_scores["3"]
    post_alignment_scores[4] = alignment_test.post_alignment_scores["4"]
    post_alignment_scores[5] = alignment_test.post_alignment_scores["5"]
    post_alignment_scores[6] = alignment_test.post_alignment_scores["6"]
  }

  const valueResponseCount =
    alignment_test.post_responses["value1"].length +
    alignment_test.post_responses["value2"].length +
    alignment_test.post_responses["value3"].length +
    alignment_test.post_responses["value4"].length +
    alignment_test.post_responses["value5"].length

  const goalResponseCount =
    alignment_test.post_responses["goal1"].length +
    alignment_test.post_responses["goal2"].length +
    alignment_test.post_responses["goal3"].length

  let saving = $state(false)

  let errors: any = {}
  async function submitPostAlignmentScores(): Promise<void> {
    if (
      !post_alignment_scores[1] ||
      !post_alignment_scores[2] ||
      !post_alignment_scores[3] ||
      !post_alignment_scores[4] ||
      !post_alignment_scores[5]
    ) {
      alert("Enter a score for each question")
      return
    }

    try {
      saving = true
      const resp = await xhr.patch(
        `/admin/alignment_tests/${alignment_test.id}.json`,
        {
          alignment_test: { post_alignment_scores: post_alignment_scores }
        }
      )
      alignment_test = resp.data
      toast("Post-Alignment Test Scoring Submitted", "success")
    } catch (e) {
      console.log(e)
      toast("There was an error submitting scores", "error")
      errors = e.response.data.errors
    } finally {
      saving = false
    }
  }
</script>

{#if alignment_test.status == "collecting_post_alignment_responses" && responses.length == 0}
  <div class="mt-6 flex justify-center">
    <p
      class="py-2 px-6 border-amber-100 bg-amber-50 text-amber-600 border text-lg"
    >
      Post-Alignment Test has started but no responses have been completed yet.
    </p>
  </div>
{:else}
  {#if alignment_test.status == "collecting_post_alignment_responses"}
    <div class="mt-6 flex justify-center">
      <p
        class="py-2 px-6 border-amber-100 bg-amber-50 text-amber-600 border text-lg"
      >
        Not all users have completed the test yet, responses collected so far
        are shown below.
      </p>
    </div>
  {:else if alignment_test.status == "scoring_post_test_responses"}
    <div class="mt-6 flex justify-center">
      <p
        class="py-2 px-6 border-blue-100 bg-blue-50 text-blue-600 border text-lg"
      >
        All tests have now been completed, please calculate scoring and enter
        final scores below.
      </p>
    </div>
  {/if}
  {#each [1, 2, 3, 4, 5, 6] as id}
    <div class="p-6 border border-amber-50 shadow rounded">
      <p class="text-xl text-grey-600 mr-2">
        <span class="text-2xl text-amber-700 font-bold mr-2">{id}.</span>
        {#if id == 1}
          One a scale of 1-10, how aligned and on the same page is your team?
        {:else if id == 2}
          What is the company's Brand Purpose?
        {:else if id == 3}
          What is the company's Blue Sky Vision?
        {:else if id == 4}
          What are the top five Values of the company from most to least
          important?
        {:else if id == 5}
          What are your team's top 3 Annual Goals this year?
        {:else if id == 6}
          Rate how important it is for people to know the answers to these
          questions.
        {/if}
      </p>
      <div class="grid grid-cols-5">
        <div class="border-b border-grey-200 col-span-4">
          <p
            class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0 w-90"
          >
            {#if [1, 2, 3, 6].includes(id)}
              Responses ({alignment_test.post_responses[`q${id}`].length} Responses
              Total)
            {:else if id == 4}
              Responses ({valueResponseCount} Responses Total)
            {:else if id == 5}
              Responses ({goalResponseCount} Responses Total)
            {/if}
          </p>
        </div>
        <div class="border-b border-grey-200">
          <p
            class="px-3 py-3.5 text-center text-sm font-semibold text-gray-900 w-10"
          >
            Score
          </p>
        </div>
        <div class="mt-4 col-span-4">
          {#if [1, 2, 3, 6].includes(id)}
            <div
              class="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 col-span-4 grid grid-cols-3 gap-2"
            >
              {#each alignment_test.post_responses[`q${id}`].sort() as response, count}
                <ResponseBox {response} {count} />
              {/each}
            </div>
          {:else if id == 4}
            {#each [1, 2, 3, 4, 5] as value}
              <div
                class="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 col-span-4 flex gap-3 items-center"
              >
                <p class="text-lg font-bold px-4 whitespace-nowrap">
                  Value #{value}
                </p>
                <div class="flex-grow grid grid-cols-4 gap-2">
                  {#each alignment_test.post_responses[`value${value}`].sort() as response, count}
                    <ResponseBox {response} {count} />
                  {/each}
                </div>
              </div>
            {/each}
          {:else if id == 5}
            {#each [1, 2, 3] as value}
              <div
                class="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 col-span-4 flex gap-3 items-center"
              >
                <p class="text-lg font-bold px-4 whitespace-nowrap">
                  Goal #{value}
                </p>
                <div class="flex-grow grid grid-cols-4 gap-2">
                  {#each alignment_test.post_responses[`goal${value}`].sort() as response, count}
                    <ResponseBox {response} {count} />
                  {/each}
                </div>
              </div>
            {/each}
          {/if}
        </div>
        <div>
          {#if alignment_test.status == "collecting_post_alignment_responses"}
            <div
              class="mt-4 border border-gray-200 rounded-md p-4 shadow-sm bg-white text-center"
            >
              <span class="text-sm text-gray-500 italic text-center">
                Awaiting Responses
              </span>
            </div>
          {:else if alignment_test.status === "scoring_post_test_responses"}
            <div
              class="mt-4 border border-gray-300 rounded-md p-4 shadow bg-white"
            >
              <div class="input-cont">
                <label for="">Q{id} Score</label>
                <div class="relative mt-2 rounded-md shadow-sm">
                  <input type="text" bind:value={post_alignment_scores[id]} />
                  <div
                    class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
                  >
                    %
                  </div>
                </div>
              </div>
            </div>
          {:else if alignment_test.post_scoring_completed_at}
            <div
              class="mt-4 border border-gray-300 rounded-md p-4 shadow bg-white text-center"
            >
              <span class="text-lg font-bold">
                {post_alignment_scores[id]}%
              </span>
            </div>
          {/if}
        </div>
      </div>
    </div>
  {/each}

  {#if alignment_test.status === "scoring_post_test_responses"}
    <div class="mt-4 text-center">
      <button
        class="py-2 px-3 bg-amber-700 text-white rounded shadow"
        disabled={saving}
        onclick={submitPostAlignmentScores}
      >
        Submit Post-Alignment Score
      </button>
    </div>
  {/if}
{/if}
